export default "__VITE_ASSET__C5beyUXu__"